import React, {useEffect, forwardRef, useImperativeHandle} from "react";
import "./style.scss";
import {useImagePreloader} from "../../hooks/useImagePreloader";

const normalizeSelections = (value) => {
    if (Array.isArray(value)) {
        return value;
    }

    if (value === undefined || value === null || value === "") {
        return [];
    }

    return [value];
};

export const QuestionnaireMultiple = ({list, clickNext, value, clicked, setAllow, isCurPage}) => {
    const [selects, setSelects] = React.useState(() => normalizeSelections(value));
    const { isAllLoaded, loadingImages } = useImagePreloader([
        "/static/image/icon/selected.png",
        "/static/image/icon/unselect.png"
    ], true);

    useEffect(() => {
        setSelects(normalizeSelections(value));
    }, [value]);

    const handleSelectChange = (value, index) => {
        if (selects?.includes(value)) {
            setSelects(selects.filter(item => item !== value));
        } else {
            const isNone = list?.list[index].isNone;
            if(isNone) {
                setSelects([value]);
            } else {
                const filterSelects = selects?.filter(item => {
                    const find = list?.list?.find(i => i.value === item);

                    return !find?.isNone;
                });

                setSelects([...filterSelects, value]);
            }
        }
    }
    useEffect(() => {
        setAllow(selects.length !== 0);
    }, [selects, setAllow]);

    useEffect(() => {
        if (clicked && isCurPage && selects.length !== 0) {
            clickNext(selects);
        }
    }, [clicked, clickNext, isCurPage, selects]);

    return <div className={'questionnaire-multiple'}>
        <div className={'questionnaire-multiple-title'}>
            {list?.title}
        </div>
        {list?.subtitle && <div className={'questionnaire-multiple-subtitle'}>
            {list.subtitle}
        </div>}
        <div className={'questionnaire-multiple-list'}>
            {list.list?.map((item, index) => {
                return <div className={`questionnaire-multiple-item ${selects?.includes(item?.value) ? "questionnaire-multiple-item-select" : ""}`} onClick={() => {handleSelectChange(item?.value, index)}} key={index}>
                    <div className={'questionnaire-multiple-item-content'}>
                        {item?.value}
                    </div>
                    <img src={selects?.includes(item?.value) ? "/static/image/icon/selected.png" : "/static/image/icon/unselect.png"} alt="" className={"questionnaire-multiple-item-icon"} />
                </div>
            })}
        </div>
    </div>;
};

QuestionnaireMultiple.propTypes = {};
